import { render, staticRenderFns } from "./Air.vue?vue&type=template&id=0438043c&scoped=true"
import script from "./Air.vue?vue&type=script&lang=js"
export * from "./Air.vue?vue&type=script&lang=js"
import style0 from "./Air.vue?vue&type=style&index=0&id=0438043c&lang=less&scoped=true"
import style1 from "./Air.vue?vue&type=style&index=1&id=0438043c&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0438043c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0438043c')) {
      api.createRecord('0438043c', component.options)
    } else {
      api.reload('0438043c', component.options)
    }
    module.hot.accept("./Air.vue?vue&type=template&id=0438043c&scoped=true", function () {
      api.rerender('0438043c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/Air.vue"
export default component.exports